import type { ComponentWithSource } from "../api/componentsData"
import { buildCollectionPath } from "../utils/collectionPaths"
import { isOrganizationScopingDisabled } from "../utils/organizationScoping"

type ComponentNavMeta = ComponentWithSource & { organization?: string | null }

export function isExactPath(pathname: string, path: string): boolean {
  const p = pathname.replace(/[/]+$/, "") || "/"
  const q = path.replace(/[/]+$/, "") || "/"
  return p === q
}

export function isPathPrefix(pathname: string, base: string): boolean {
  if (base === "/") return isExactPath(pathname, "/")
  const p = pathname.replace(/[/]+$/, "") || "/"
  const b = base.replace(/[/]+$/, "") || "/"
  return p === b || p.startsWith(`${b}/`)
}

export function isActiveCollectionRow(pathname: string, component: ComponentNavMeta): boolean {
  const slug =
    typeof component.slug === "string" ? component.slug.replace(/[!]+$/, "").trim() : ""
  if (!slug) return false
  const path = buildCollectionPath({
    slug,
    organization: isOrganizationScopingDisabled() ? undefined : (component.organization ?? null),
  })
  const norm = (p: string) => p.replace(/[/]+$/, "") || "/"
  return norm(pathname) === norm(path)
}
